<template>
  <div>
    <!-- Adviseurs omgeving; Gebruikers adviseur -->
    <div id="firstMenubar" class="row roundedtop menubar">
      <div class="title">Klanten</div>
      <a
        v-if="style == 'db'"
        href="https://www.doelbeleggen.nl/agenda/atp"
        target="_blank"
        class="button"
        style="float:right"
      >
        <awesomeIcon icon="phone-alt"/>
        <span class="mobile-hidden">Plan een belafspraak in</span>
      </a>
    </div>
    <div class="card inset-small marginbottom roundedBottom">
      <h3 class="backgroundTitle">Samen Doelbeleggen - dé portal voor adviserend Nederland</h3>
      <p style="line-height: 150%">
        Dit is uw klanten overzicht. Hier heeft u een overzicht van uw bestaande klanten. In het
        menu aan de linkerzijde kunt u navigeren naar de andere onderdelen van de Samen Doelbeleggen
        portal.
        </p>
    </div>
    <!-- Customer overview -->
    <tableFilter
      name="atpUsersFilters"
      ref="filterComp"
      :activeAmount="activeFilters"
      :mainFunction="getAtpCustomers"
      v-model="filters"
    />
    <div class="card" v-if="allClients !== null">
      <table>
        <thead class="table-legend">
          <tr>
            <th>#</th>
            <th>Klantgegevens</th>
            <th>Portefeuille</th>
            <th>Doelstelling</th>
            <th>Uw kosten</th>
          </tr>
        </thead>
        <tr
          v-for="client in allClients"
          :key="client.port"
          @mouseover="selected = `port${client.port}client${client.client}`"
          @mouseout="selected = null"
        >
          <td>{{ client.port || '-' }}</td>
          <td>
            {{ client.user }}
            <br />
            <span class="grey concat" :title="client.email">{{ client.email }}</span>
            <br />
            <template v-if="client.phoneNumber">
              {{ client.phoneNumber }}
            </template>
            <span v-else class="grey">-</span>
          </td>
          <td>
            Waarde: &euro;{{formatPrice(client.value, true)}},-
            <br />
            <span class="grey"> Profiel: {{ client.profile || '-' }}</span>
            <br />
            {{ client.goal }}
          </td>
          <td>
            Doeldatum {{(new Date(client.targetDate)).toLocaleDateString()}}
            <br />
            <span class="grey">
              Looptijd
              <b v-if="daysTillGoal(client.targetDate) > 365">
                {{Math.ceil(daysTillGoal(client.targetDate) / 366)}} jaar
              </b>
              <b v-else-if="daysTillGoal(client.targetDate) > 1">
                {{Math.ceil(daysTillGoal(client.targetDate))}} dagen
              </b>
              <b v-else-if="daysTillGoal(client.targetDate) > 0">
                1 dag
              </b>
            </span>
            <br />
            Lifecycle:
            <span
              :class="{
                'green': client.lifecycle,
                'red': !client.lifecycle,
              }"
            >
              {{client.lifecycle ? 'Aan ' : 'Uit '}}
            </span>
            <awesomeIcon
              style="cursor: help"
              icon="info-circle"
              :title="infoTitle(client.lifecycle)"
            />
          </td>
          <td v-if="`port${client.port}client${client.client}` !== selected">
            Eenmalig: &euro;{{formatPrice(client.feeOnce, true)}},-
            <br />
            <span class="grey">
              &euro; per jaar: &euro;{{formatPrice(client.feeYearEuro, true)}},-
            </span>
            <br />
            % per jaar: {{formatPrice(client.feeYearPercentage)}}%
          </td>
          <td v-else>
            <button
              class="secondary"
              @click="becomeUser(client.client)"
            >
              <awesomeIcon icon="eye" /> Bekijk
            </button>
          </td>
        </tr>
        <tr v-if="allClients.length === 0">
          <td colspan="5">
            Geen resultaten
          </td>
        </tr>
      </table>
      <pagerElement
        v-model="currentPage"
        :records="totalClients"
        :resultsPerPage="maxPerPage"
      />
    </div>
    <div v-else class="loader"/>

  </div>
</template>

<script>

export default {
  name: 'atpCustomers',
  data() {
    return {
      style: process.env.VUE_APP_STYLE,
      allClients: null,
      totalClients: null,
      currentPage: 0,
      maxPerPage: 10,
      selected: null,
      activeFilters: [],
      filters: [
        {
          name: 'generalInput',
          model: '',
          cookie: 'atpCustomersGeneralInput',
          filterName: 'search',
          operator: 'contains',
          operators: ['eq', 'contains', 'startswith', 'endswith'],
          title: 'Naam, E-mail adres, telefoonnummer, Portefeuille nummer',
        },
        {
          name: 'portInput',
          label: 'Port. nummer (#)',
          type: 'string',
          cookie: 'atpCustomersPortInput',
          model: '',
          filterName: 'port',
          operator: 'contains',
          operators: ['eq', 'contains', 'lt', 'gt'],
        },
        {
          name: 'sortInput',
          type: 'dropdown',
          position: 'topbar',
          cookie: 'atpCustomersSortInput',
          model: '',
          attributes: [
            {
              name: 'array',
              value: [
                {
                  label: 'Vragenlijst',
                  value: 'intake',
                },
                {
                  label: 'Naam',
                  value: 'user',
                },
                {
                  label: 'E-mail',
                  value: 'email',
                },
                {
                  label: 'Doeltype',
                  value: 'goal',
                },
                {
                  label: 'Vragenlijst voortgang',
                  value: 'progress',
                },
              ],
            },
            {
              name: 'displayPrefix',
              value: 'Sort: ',
            },
            {
              name: 'defaultValue',
              value: 'intake',
            },
            {
              name: 'cb',
              value: () => {
                this.currentPage = 0;
                this.$refs.filterComp.get();
              },
            },
          ],
        },
        {
          name: 'sortDirectionInput',
          type: 'dropdown',
          position: 'topbar',
          cookie: 'atpCustomersSortDirectionInput',
          model: '',
          attributes: [
            {
              name: 'array',
              value: [
                {
                  label: 'Aflopend',
                  value: 'desc',
                },
                {
                  label: 'Oplopend',
                  value: 'asc',
                },
              ],
            },
            {
              name: 'defaultValue',
              value: 'asc',
            },
            {
              name: 'cb',
              value: () => {
                this.currentPage = 0;
                this.$refs.filterComp.get();
              },
            },
          ],
        },
      ],
    };
  },
  watch: {
    currentPage() {
      this.$refs.filterComp.get();
    },
  },
  methods: {
    infoTitle(lc) {
      if (Number(lc) === 1) {
        return 'Dit betekent dat wij richting het eind van de looptijd het risico binnen de portefeuille afbouwen zodat de kans op een \n nog moeilijk te herstellen verlies afneemt. Mocht u hierover vragen hebben, neem dan contact met ons op.';
      }
      return 'Het risico binnen de portefeuille wordt richting het eind van de looptijd niet afgebouwd. \n Mocht u hierover vragen hebben, neem dan contact met ons op.';
    },
    daysTillGoal(date) {
      return (
        (new Date(date)).getTime()
        - (new Date()).getTime()
      ) / 1000 / 24 / 60 / 60;
    },
    becomeUser(user) {
      this.sdk.become(user, (response) => {
        if (response.status === 200) {
          window.location.reload();
        }
      });
    },
    getAtpCustomers(newSearch, filter = '', activeFilters = []) {
      this.activeFilters = activeFilters;

      if (this.activeFilters.length) {
        this.$refs.filterComp.toggle(true);
      }

      filter.push('status eq customer');
      if (filter.length) {
        filter = filter.join(';');
      }

      if (newSearch) {
        this.currentPage = 0;
      }

      // Check sorting filter
      const sort = this.$refs.filterComp.getValue('sortInput');
      const sortDirection = this.$refs.filterComp.getValue('sortDirectionInput');

      this.sdk.getAtpCustomers((response) => {
        if (response.status === 200) {
          this.totalClients = response.data.totalRows;
          const temp = [];
          for (let i = 0; i < response.data.results.length; i += 1) {
            const obj = {
              accepted: response.data.results[i].accepted,
              advisor: response.data.results[i].advisor,
              client: response.data.results[i].client,
              companyName: response.data.results[i].company_name,
              connected: response.data.results[i].connected,
              email: response.data.results[i].email,
              feeOnce: response.data.results[i].fee_once,
              feeYearEuro: response.data.results[i].fee_year_euro,
              feeYearPercentage: (response.data.results[i].fee_year_percentage / 100),
              goal: response.data.results[i].goal,
              intake: response.data.results[i].intake,
              lastPositionDate: response.data.results[i].last_position_date,
              lifecycle: response.data.results[i].lifecycle,
              phoneNumber: response.data.results[i].phone_number,
              port: response.data.results[i].port,
              profile: response.data.results[i].profile,
              progress: response.data.results[i].progress,
              score: response.data.results[i].score,
              startAmount: response.data.results[i].start_amount,
              status: response.data.results[i].status,
              targetDate: response.data.results[i].target_date,
              user: response.data.results[i].user,
              value: response.data.results[i].value !== null ? response.data.results[i].value : 0,
            };
            temp.push(obj);
          }
          this.allClients = temp;
        } else {
          // Not able to retrieve users
        }
      }, filter, this.currentPage, this.maxPerPage, sort, sortDirection);
    },
  },
};
</script>

<style lang="scss" scoped>
  .green-title {
    color: $color-highlight;
  }
  @media #{$mobile} {
    #firstMenubar {
      top: 91px !important;
    }
  }
</style>
